import { combineReducers } from 'redux';

// import Quizzes from '../Quiz';
import oQuiz from '../data/Questions.json';

import {
	ADD_ANSWER
} from '../actions/quiz';

/**
 * Question reducer
 * @param state
 * @param action
 * @returns {Array}
 */
function questions(state = oQuiz, action) {
	switch(action.type) {
		case ADD_ANSWER:
			const { quiz, answer, questionID } = action.data;
			let questionIDParsed = parseInt(questionID, 10);
			let tempArray = [];

			quiz.questions.forEach((oQuestion) => {
				if (oQuestion.id === questionIDParsed) {
					oQuestion.givenAnswers = answer;
				}
				tempArray.push(oQuestion);
			});

			return tempArray;
		default:
			return state;
	}
}

export default combineReducers({
	questions
});


// WEBPACK FOOTER //
// ./src/reducers/quiz.js